export enum IntegrationKind {
  WHATSAPP = "WHATSAPP",
  WHATSAPP_META = "WHATSAPP_META",
  WHATSAPP_DIRECT = "WHATSAPP_DIRECT",
  FACEBOOK = "FACEBOOK",
  FACEBOOK_META = "FACEBOOK_META",
  GOOGLE_DRIVE = "GOOGLE_DRIVE",
}
